import React, { memo,useEffect } from 'react'
import { useRoutes } from 'react-router-dom'
import routes from './router'

//memo 允许你的组件在 props 没有改变的情况下跳过重新渲染。
const App = memo(() => {
  return (
    <div className='app'>
      <div className='page'>
        {useRoutes(routes)}
      </div>
    </div>
  )
})

export default App
